export default __webpack_public_path__ + "static/Sarah-04dee53ff6709a3b1c0bbe0023554a46.png";